<template>
  <ModalBase :boxShadow="modalBoxShadow" baseBackground="rgb(255 255 255 / 42%)"
    ><div
      class="request-rematch"
      :style="past2Min || timeLeftToRematch ? 'height: 675px;' : ''"
    >
      <CloseModalButton @closeModal="closeModal" v-if="!rematchRequestDoc" />
      <div
        class="request-rematch-header"
        v-if="!rematchRequestDoc && !newPartner"
      >
        <div class="request-rematch-header-text">
          Looks like your partner is running late!
        </div>
      </div>
      <div
        class="request-rematch-body"
        v-if="!rematchRequestDoc && !newPartner"
      >
        <div class="request-rematch-section">
          <ul>
            <div class="request-rematch-card">
              <div class="request-rematch-check">⛵</div>
              <div class="request-rematch-card-text">
                Sometimes people end up in the same boat, where their session
                partners haven't arrived by now and they're waiting on their
                own.
              </div>
            </div>
            <div class="request-rematch-card">
              <div class="request-rematch-check">🚀</div>
              <div class="request-rematch-card-text">
                If one of those people is out there right now, we can connect
                you! However, you can also choose to wait for your partner.
              </div>
            </div>
            <div class="request-rematch-card">
              <div class="request-rematch-check">✅</div>
              <div class="request-rematch-card-text">
                If your current partner arrives first, we'll keep you matched
                with them. You can also always cancel your request for a new
                partner.
              </div>
            </div>
          </ul>
        </div>
      </div>
      <div
        class="request-rematch-area"
        :class="rematchRequestDoc || newPartner ? 'waiting-area' : ''"
      >
        <div
          class="request-rematch-section-title"
          v-if="!rematchRequestDoc && !newPartner"
        >
          Would you like us to try and connect you with a new partner?
        </div>

        <!-- IF REQUESTING NEW PARTNER && REMATCH DOC EXISTS && NO PARTNER YET -->
        <div
          class="request-rematch-section-title waiting-title"
          v-else-if="rematchRequestDoc && !newPartner"
        >
          <div>
            <span>Looking for a new partner...</span>
          </div>
          <img
            class="request-waiting-image"
            src="https://ik.imagekit.io/elysiumone/charlie_2ztSBkHcwFS.gif"
          />
        </div>

        <!-- NEW PARTNER HAS BEEN FOUND, NO REMATCH DOC ANY MORE -->
        <div
          class="request-rematch-section-title waiting-title"
          v-else-if="!rematchRequestDoc && newPartner"
        >
          <div>Get ready to meet your new partner!</div>
          <ik-image
            loading="lazy"
            :transformation="[{ height: 60, width: 60 }]"
            v-if="
              newPartner &&
              newPartner.metadata &&
              newPartner.metadata.profileImageUrl
            "
            :src="newPartner.metadata.profileImageUrl"
            class="request-rematch-picture"
          />
          <div v-else class="request-rematch-picture smallBorder">
            <IconBase
              icon-name="profile"
              iconColor="#222"
              viewBox="0 0 32 32"
              width="100%"
              height="100%"
              strokeWidth="0px"
              ><IconProfileImg
            /></IconBase>
          </div>
          <span
            class="partner-display-name"
            v-if="
              newPartner &&
              newPartner.metadata &&
              newPartner.metadata.displayName
            "
            >{{ newPartner.metadata.displayName }}</span
          >
          <div class="switching-partner">Switching to new session...</div>
        </div>

        <!-- CONTROL NAVIGATION FOR REQUESTING PARTNER, CANCELING REQUEST, WAITING PARTNER -->
        <div class="rematch-navigation" v-if="!newPartner">
          <div class="rematch-nav-buttons">
            <div
              class="wait-partner-btn"
              @click="waitForPartner"
              v-if="!rematchRequestDoc && !newPartner"
            >
              Wait for partner
            </div>
            <div
              class="request-rematch-btn"
              @click="requestNewPartner"
              v-if="!rematchRequestDoc && !newPartner"
            >
              {{ requestMatchButtonText }}
            </div>
            <div
              class="cancel-request-btn"
              v-if="rematchRequestDoc && !newPartner"
              @click="cancelRematchRequest"
            >
              Cancel request
            </div>
          </div>
          <div class="minutes-left" v-if="timeLeftToRematch">
            <span>{{
              `${timeLeftToRematch} minutes left to request a rematch.`
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </ModalBase>
</template>

<script>
import { mapState } from "vuex";
import ModalBase from "../../../../../components/InfoModalBase/ModalBase.vue";
import CloseModalButton from "../../../../../components/Widgets/CloseModalButton/CloseModalButton.vue";
import rematchSocket from "../../../../../socket/rematchSocket";
import IconBase from "../../../../../components/IconBase.vue";
import IconProfileImg from "../../../../../components/SVG/IconProfileImg.vue";

export default {
  name: "InfoModal",
  components: {
    ModalBase,
    CloseModalButton,
    IconBase,
    IconProfileImg,
  },
  data() {
    return {
      modalBoxShadow:
        "rgb(15 15 15 / 5%) 0px 0px 0px 1px, rgb(15 15 15 / 10%) 0px 3px 6px, rgb(213 213 213 / 20%) 0px 9px 24px",

      rematchRequestFailed: false,
      rematchRequestCancelFailed: false,
      checkingExistingRematchRequestFailed: false,

      requestMatchButtonText: "Request new partner",
    };
  },
  props: {
    SID: String /* Session ID */,
    UID: String /* User ID */,
    dateTimeMS: Number /* Session start time in MS */,
    past2Min: Boolean,
    timeLeftToRematch: [String, Boolean],
  },
  computed: {
    ...mapState({
      rematchRequestDoc: (state) => state.rematching.rematchRequestDoc,
      newPartner: (state) => state.rematching.newPartner,
      remoteParticipantData: (state) => state.room.remoteParticipantData,
    }),
  },
  async created() {
    await this.checkExistingRematchRequest();
  },
  methods: {
    waitForPartner() {
      this.$store.dispatch("modals/setModalState", {
        modal: "rematching",
        newState: false,
      });
    },
    async delay(ms) {
      return new Promise((res) => setTimeout(res, ms));
    },
    async checkExistingRematchRequest() {
      const result = await rematchSocket.checkExistingRematchRequest(
        this.SID,
        this.UID
      );
      console.log("request new partner result: ", result);
      if (result.success) {
        /* This can be null */
        if (result.rematchRequestDoc) {
          this.$store.dispatch(
            "rematching/setRematchRequestDoc",
            result.rematchRequestDoc
          );
        }
      } else {
        this.checkingExistingRematchRequestFailed = true;
      }
    },
    async requestNewPartner() {
      this.requestMatchButtonText = "Requesting...";
      const result = await rematchSocket.requestOneRematch(
        this.SID,
        this.UID,
        this.dateTimeMS
      );
      if (result.success) {
        if (result.rematchedSession && result.rematchedSession._id) {
          result.rematchedSession.partnerIndex = 1;

          this.$store.dispatch(
            "rematching/setSuccesfulRematchData",
            result.rematchedSession
          );
          await this.delay(3000);
          this.$emit("rebootWithNewSessionID", result.rematchedSession._id);
        } else if (result.newRematchRequest) {
          this.$store.dispatch(
            "rematching/setRematchRequestDoc",
            result.newRematchRequest
          );
        } else if (result.alreadyRequestedRematch) {
          this.$store.dispatch(
            "rematching/setRematchRequestDoc",
            result.alreadyRequestedRematch
          );
        }
      } else {
        this.rematchRequestFailed = true;
      }
      this.requestMatchButtonText = "Request new partner";
    },
    async cancelRematchRequest() {
      const result = await rematchSocket.cancelOneRematchRequest(
        this.SID,
        this.UID
      );
      if (result.success) {
        this.$store.dispatch("rematching/setRematchRequestDoc", null);
      } else {
        this.rematchRequestCancelFailed = true;
      }
    },
    closeModal() {
      this.$store.dispatch("modals/setModalState", {
        modal: "rematching",
        newState: false,
      });
    },
  },
};
</script>

<style scoped>
.request-rematch {
  width: 600px;
  height: 640px;
  padding: 0px 55px;
  padding-top: 20px;
  box-sizing: border-box;
  overflow: hidden;
  padding-bottom: 20px;
}
.rematch-navigation {
  display: flex;
  flex-direction: column;
  margin: 0px auto;
  justify-content: center;
  align-items: center;
}
.rematch-nav-buttons {
  display: flex;
  flex-direction: row;
  margin: 0px auto;
  justify-content: center;
  align-items: center;
}
.request-rematch-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px auto;
  flex-direction: column;
  box-sizing: border-box;
  margin-top: 50px;
  margin-bottom: 24px;
}
.request-rematch-header-text {
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -0.5px;
  width: 400px;
  text-align: center;
}
.request-rematch-body {
  height: 255px;
  width: 430px;
  margin: 0px auto;
}
.request-rematch-btn,
.cancel-request-btn,
.wait-partner-btn {
  font-size: 18px;
  letter-spacing: 0.5px;
  padding: 4px 18px;
  font-weight: 700;
  border-radius: 360px;
  cursor: pointer;
  transition: 0.1s ease;
  text-align: center;
  outline: none;
  border-color: unset;
  border: none;
  box-sizing: border-box;
  min-width: 85px;
  margin: auto;
  font-family: "Nunito", sans-serif;
  background-color: #111;
  color: white;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 7.5px;
  margin-right: 7.5px;
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px,
    rgb(15 15 15 / 10%) 0px 3px 6px, rgb(82 82 82 / 20%) 0px 9px 24px;
}
.request-rematch-btn:hover {
  background-color: #454545;
}
.wait-partner-btn,
.cancel-request-btn {
  color: #111;
  background-color: white;
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px,
    rgb(15 15 15 / 10%) 0px 3px 6px, rgb(149 149 149 / 20%) 0px 9px 24px;
}
.wait-partner-btn:hover,
.cancel-request-btn:hover {
  background-color: #ebebeb;
}
.request-rematch-card {
  padding: 3px 0px !important;
  box-sizing: border-box;
  font-size: 17px;
  margin: 8px 0px;
  border-radius: 12px;
  width: 90%;
  margin-left: 20px !important;
  margin-right: auto;
  display: flex;
  line-height: 24px;
}

.request-rematch-check {
  margin-right: 10px;
}
.request-rematch-section-title {
  text-align: center;
  font-size: 22px;
  width: 380px;
  font-weight: 600;
  justify-content: center;
  display: flex;
  line-height: 30px;
  margin: 0px auto;
  margin-bottom: 22px;
  flex-direction: column;
}
.waiting-title {
  font-size: 30px;
  width: 400px;
}
.request-rematch-title p {
  margin-top: 26px !important;
}
.request-rematch-area {
  background-color: white;
  box-shadow: 0 0 0 1px rgb(209 209 209 / 5%), 0 3px 6px rgb(15 15 15 / 10%),
    0 9px 24px rgb(120 120 120 / 20%);
  border-radius: 12px;
  padding: 32px 0px;
  width: 485px;
  margin: 0px auto;
  margin-top: 15px;
}
.waiting-area {
  margin-top: 42px;
  background-color: transparent;
  box-shadow: unset;
}
.request-waiting-image {
  height: 335px;
  width: 400px;
  border-radius: 12px;
  box-shadow: 0 0 0 1px rgb(209 209 209 / 5%), 0 3px 6px rgb(15 15 15 / 10%),
    0 9px 24px rgb(120 120 120 / 20%);
  margin: 0px auto;
  box-sizing: border-box;
  margin-top: 25px;
}
.switching-partner {
  font-size: 20px;
  margin-top: 20px;
}
.request-rematch-picture {
  width: 200px;
  height: 200px;
  border-radius: 360px;
  border: 2px solid transparent;
  z-index: 999;
  -o-object-fit: cover;
  object-fit: cover;
  box-sizing: border-box;
  margin: 0px auto;
  margin-top: 25px;
  margin-bottom: 15px;
}
.partner-display-name {
  max-width: 250px;
  text-align: center;
  margin: 0px auto;
}
.minutes-left {
  font-size: 16px;
  margin-top: 20px;
}
</style>